module.exports = __webpack_public_path__ + "media/images/pack-bg-02-a5f70cd36995f51131e5ffe1cca38411.svg";